var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar navbar-expand-lg navbar-fixed" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("a", { staticClass: "navbar-brand" }, [_vm._v("Cek Invoice")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "collapse navbar-collapse justify-content-end" },
        [
          _c(
            "ul",
            { staticClass: "navbar-nav" },
            [
              _c("drop-down", { attrs: { position: "right" } }, [
                _c("i", {
                  staticClass: "nc-icon nc-bullet-list-67",
                  attrs: { slot: "title" },
                  slot: "title"
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item text-danger",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        _vm.doRemove()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "nc-icon nc-button-power" }),
                    _vm._v(" Keluar\n          ")
                  ]
                )
              ])
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f5d75f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f5d75f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Layout/TopNavbar.vue
// module id = S2Mr
// module chunks = 4